import React from 'react'
import ReactDOM from 'react-dom'
import BrowserDetect from 'browser-detect'
import injectTapEventPlugin from 'react-tap-event-plugin'
import createStore from './store/createStore'
import projectPackage from '../package.json'
import skinToggle from './util/skinToggle.js'

// Toggle User Interface Styling for the entire Redd App based on the business domain - Walmart, Samsclub, etc
toggleStylesheetLoad()

// Rover Application Initilization - START
var ieBrowserCheck = BrowserDetect()
if (ieBrowserCheck.name == 'ie' && ieBrowserCheck.versionNumber < 10) {
  window.location = 'browser-error.html'
}
// Rover Application Initilization - END

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin()

// Store Initialization
// ------------------------------------
const store = createStore(window.__INITIAL_STATE__)

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root')

let render = () => {
  const App = require('./components/App').default
  const routes = require('./routes/index').default(store)

  ReactDOM.render(
    <App store={store} routes={routes} />,
    MOUNT_NODE
  )
}

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    render = () => {
      try {
        renderApp()
      } catch (e) {
        console.error(e)
        renderError(e)
      }
    }

    // Setup hot module replacement
    module.hot.accept([
      './components/App',
      './routes/index',
    ], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    )
  }
}

/**
  ---- Function Definition ---

Toggle the import of Styling sheets based on 'skin'. 
*/

function toggleStylesheetLoad () {
  let skinQueryParam = window.location.href.toLowerCase().match(/skin=([^&]*)/i)
  let skin = skinToggle.getSkin(skinQueryParam && skinQueryParam[1])
  var ss = document.createElement('link')
  ss.type = 'text/css'
  ss.rel = 'stylesheet'
  var faviconLink = document.createElement('link')
  faviconLink.rel = 'icon'
  var titleLink = document.createElement('title')
  
  if (skin === 'walmart') {
    includeWalmartStyle(ss, faviconLink, titleLink)
  } else if (skin === 'sams') {
    includeSamsStyle(ss, faviconLink, titleLink)
  } else if (skin === 'walmartonline') {
    includeWalmartOnlineStyle(ss, faviconLink, titleLink)    
  } else {
      // default skin is samsclub
    includeSamsStyle(ss, faviconLink, titleLink)
  }
}

function includeWalmartStyle (ss, faviconLink, titleLinks) {
  require('./styles/css/walmart.scss')    // This includes the stylesheet in the project for local env
  document.getElementsByTagName('title')[0].innerHTML = 'Document Delivery - Walmart'
  faviconLink.href = 'walmart_favicon.ico'
  document.getElementsByTagName('head')[0].appendChild(faviconLink)
  ss.href = './styles/walmart.' + projectPackage.version + '.css'        // This includes the stylesheet in the project for deployment on the server (any non-local env).
  document.getElementsByTagName('head')[0].appendChild(ss)    // Injects the stylesheet into the HTML for deployment on the server (any non-local env)
}

function includeWalmartOnlineStyle (ss, faviconLink, titleLinks) {
  require('./styles/css/walmartonline.scss')    // This includes the stylesheet in the project for local env
  document.getElementsByTagName('title')[0].innerHTML = 'Document Delivery - Walmart Online'
  faviconLink.href = 'walmart_favicon.ico'
  document.getElementsByTagName('head')[0].appendChild(faviconLink)
  ss.href = './styles/walmartonline.' + projectPackage.version + '.css'        // This includes the stylesheet in the project for deployment on the server (any non-local env).
  document.getElementsByTagName('head')[0].appendChild(ss)    // Injects the stylesheet into the HTML for deployment on the server (any non-local env)
}

function includeSamsStyle (ss, faviconLink, titleLink) {
  require('./styles/css/sams.scss')      // This includes the stylesheet in the project for local env
  document.getElementsByTagName('title')[0].innerHTML = 'Document Delivery - Sam\'s Club'
  faviconLink.href = 'sams_favicon.ico'
  document.getElementsByTagName('head')[0].appendChild(faviconLink)
  ss.href = './styles/sams.' + projectPackage.version + '.css'          // This includes the stylesheet in the project for deployment on the server (any non-local env).
  document.getElementsByTagName('head')[0].appendChild(ss)  // Injects the stylesheet into the HTML for deployment on the server (any non-local env).
}

// Let's Go!
// ------------------------------------
if (!__TEST__) render()



// WEBPACK FOOTER //
// ./src/main.js